/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:10c25902-d914-4b57-b6b7-864548a7ffc9",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_a5CL2DIpS",
    "aws_user_pools_web_client_id": "47i2939a7uobhub5vh8jvq3a59",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://kmkw3jh73bapndoxf7cmcyq6ta.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_user_files_s3_bucket": "dvo2d64a75769c94990933b0356ac12e157180804-dvo",
    "aws_user_files_s3_bucket_region": "us-east-2",
    "aws_mobile_analytics_app_id": "4fb6303cf86142dba4e3a3f6c417652f",
    "aws_mobile_analytics_app_region": "us-east-1"
};


export default awsmobile;
